// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareAddressFields() {
    val props: Array<SerializableProperty<Address, *>> = arrayOf(Address_street, Address_city, Address_zip, Address_state, Address_geoCoordinate)
    Address.serializer().properties { props }
}
val <K> DataClassPath<K, Address>.street: DataClassPath<K, String> get() = this[Address_street]
val <K> DataClassPath<K, Address>.city: DataClassPath<K, String> get() = this[Address_city]
val <K> DataClassPath<K, Address>.zip: DataClassPath<K, String?> get() = this[Address_zip]
val <K> DataClassPath<K, Address>.state: DataClassPath<K, UsState> get() = this[Address_state]
val <K> DataClassPath<K, Address>.geoCoordinate: DataClassPath<K, GeoCoordinate> get() = this[Address_geoCoordinate]
inline val Address.Companion.path: DataClassPath<Address, Address> get() = path<Address>()


object Address_street: SerializableProperty<Address, String> {
    override val name: String by lazy { Address.serializer().descriptor.getElementName(0) }
    override fun get(receiver: Address): String = receiver.street
    override fun setCopy(receiver: Address, value: String) = receiver.copy(street = value)
    override val serializer: KSerializer<String> by lazy { (Address.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { Address.serializer().descriptor.getElementAnnotations(0) }
}
object Address_city: SerializableProperty<Address, String> {
    override val name: String by lazy { Address.serializer().descriptor.getElementName(1) }
    override fun get(receiver: Address): String = receiver.city
    override fun setCopy(receiver: Address, value: String) = receiver.copy(city = value)
    override val serializer: KSerializer<String> by lazy { (Address.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { Address.serializer().descriptor.getElementAnnotations(1) }
}
object Address_zip: SerializableProperty<Address, String?> {
    override val name: String by lazy { Address.serializer().descriptor.getElementName(2) }
    override fun get(receiver: Address): String? = receiver.zip
    override fun setCopy(receiver: Address, value: String?) = receiver.copy(zip = value)
    override val serializer: KSerializer<String?> by lazy { (Address.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<String?> }
    override val annotations: List<Annotation> by lazy { Address.serializer().descriptor.getElementAnnotations(2) }
    override val default: String? = null
    override val defaultCode: String? = "null" 
}
object Address_state: SerializableProperty<Address, UsState> {
    override val name: String by lazy { Address.serializer().descriptor.getElementName(3) }
    override fun get(receiver: Address): UsState = receiver.state
    override fun setCopy(receiver: Address, value: UsState) = receiver.copy(state = value)
    override val serializer: KSerializer<UsState> by lazy { (Address.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<UsState> }
    override val annotations: List<Annotation> by lazy { Address.serializer().descriptor.getElementAnnotations(3) }
}
object Address_geoCoordinate: SerializableProperty<Address, GeoCoordinate> {
    override val name: String by lazy { Address.serializer().descriptor.getElementName(4) }
    override fun get(receiver: Address): GeoCoordinate = receiver.geoCoordinate
    override fun setCopy(receiver: Address, value: GeoCoordinate) = receiver.copy(geoCoordinate = value)
    override val serializer: KSerializer<GeoCoordinate> by lazy { (Address.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<GeoCoordinate> }
    override val annotations: List<Annotation> by lazy { Address.serializer().descriptor.getElementAnnotations(4) }
}
